import styled from '@emotion/styled';
import media from 'css-in-js-media';

export const StyledPagination = styled.div`
  max-width: 870px;
  margin: 60px auto;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;

  ${media('<desktop')} {
    margin: 0;
    padding-top: 20px;
    border-top: 1px solid #e5e8ed;
  }

  .button.pagination {
    font-family: 'WorkSans-Regular', 'Helvetica', 'san-serif' !important;
    background: #fff;
    border-radius: 100px;
    color: #0069ff;
    padding: 0px 30px;
    font-size: 16px;
    height: 48px;
    border-color: #0069ff;
    font-weight: 600;
    transition: all 0.3s ease;
  }

  .button.pagination:hover {
    background: rgba(0, 105, 255, 0.1) !important;
    transition: all 0.3s ease;
  }
`;
